import styled from 'styled-components'

import Card from '@totallymoney/ui/components/Card'
import { focusStylesWithRoundedEdges } from '@totallymoney/ui/styles/focus'

export const StyledCard = styled(Card)`
    ${focusStylesWithRoundedEdges};
`
